export default "__VITE_ASSET__T4y8yJWa__"